import template from './has-furniture.jade';
import itemsHasNo from '../../../enums/has-no';

export default angular
  .module('cian.addForm.aboutBuildingHasFurniture', ['cian.addForm.aboutObjectHasFurniture'])
  .directive('cianAfAboutBuildingHasFurniture', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller() {
      this.items = itemsHasNo;
    },
    controllerAs: 'hasFurniture',
    template,
  })).name;
